<template>
  <component
    :is="useComponentType"
    :class="[useTypographyClass, 'transition-colors duration-150']"
    @click="$emit('click')"
  >
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: "Typography",
  inheritAttrs: true,
  props: {
    variant: {
      default: "p",
      type: String,
      validator: (value) => {
        const variants = [
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "p-small",
          "p",
          "p-large",
          "label",
          "span",
        ];
        return variants.includes(value);
      },
    },
  },
  computed: {
    useTypographyClass() {
      if (this.variant === "p" || this.variant === "span") {
        return "text-base";
      } else if (this.variant === "p-small") {
        return "text-sm";
      } else if (this.variant === "p-large") {
        return "text-lg";
      } else if (this.variant === "label") {
        return "text-label";
      } else if (this.variant === "h6") {
        return "text-xl font-black leading-snug";
      } else if (this.variant === "h5") {
        return "text-2xl font-black leading-snug";
      } else if (this.variant === "h4") {
        return "text-3xl font-black leading-snug";
      } else if (this.variant === "h3") {
        return "text-4xl font-black leading-snug";
      } else if (this.variant === "h2") {
        return "text-5xl font-black leading-snug";
      } else {
        return "text-6xl font-black";
      }
    },
    useComponentType() {
      if (this.variant.startsWith("p")) {
        return "p";
      }
      return this.variant;
    },
  },
};
</script>

<style>
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Inter", sans-serif;
}
</style>
